/* External */
import uniqWith from 'lodash-es/uniqWith';
import isEqual from 'lodash-es/isEqual';
import { compose } from 'redux';

/* Ott-common */
import { Tracks } from '@dtvgo/player-utils';

export const CLOSED_CAPTIONS = ' [CC]';

export const AUDIO_LANGUAGES_ORDER = {
  BR: { pt: 1, en: 2, es: 3 },
  SSLA: { es: 1, en: 2, pt: 3 },
};

export function createProcessAudioTracks(filter) {
  return compose(
    removeDuplicatedAudioTracks,
    Tracks.addIndexToUnknownTracks,
    applyFilterToTracks(filter),
    Tracks.parseAudioTracks,
  );
}

function applyFilterToTracks(filter) {
  return (tracks) => {
    if (!filter) return tracks;
    return tracks
      .filter((track) => Object.entries(filter).every(([key, value]) => track[key] === value));
  };
}

function removeDuplicatedAudioTracks(tracks) {
  if (!tracks) return tracks;
  return uniqWith(tracks, (trackA, trackB) => (
    !Tracks.isLanguageUnknown(trackA)
      && trackA.lang === trackB.lang
      && isEqual(trackA.quality, trackB.quality)
  ));
}
